import { render, staticRenderFns } from "./ModalTipoLaudo.vue?vue&type=template&id=097bea6e&lang=pug"
import script from "./ModalTipoLaudo.vue?vue&type=script&lang=js"
export * from "./ModalTipoLaudo.vue?vue&type=script&lang=js"
import style0 from "./ModalTipoLaudo.vue?vue&type=style&index=0&id=097bea6e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports